import { IsNameValid } from "../../NameValidation";
import type { SimplifySignUpFormData } from "../types";

export const isFormValid = (formData: SimplifySignUpFormData, isExplicitTosExperiment: boolean) => {
  const isNameValid = IsNameValid(formData.firstName) && IsNameValid(formData.lastName);
  const isPractitionerTypeValid = formData.practitionerType !== null;
  const isToSChecked = isExplicitTosExperiment ? formData.tosTimestamp !== "" : true;

  return isNameValid && isPractitionerTypeValid && isToSChecked;
};
